/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2018, 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'./SmartsService'
], function (SmartsService) {
	'use strict';

	class AnnotationService extends SmartsService {
		/**
		 * @public api to excute query against Smart annotation service.
		 *
		 * @param {Object} options target and querySpec Mandatory: the query specification to be sent to annotation service
		 * @returns a promise.
		 */
		runQuery(options/*, originalDeferred*/) {
			options.url = 'v1/predict/annotations/' + options.target;
			return this._runQuery(options);
		}
	}

	return AnnotationService;
});
